// Assets are served from the site root on both production and preview domains.
// PUBLIC_URL is unavailable during Node-based HTML pre-rendering.
export const ASSET = (name) => `/assets/${name}`;

export const PHONE = { display: "0431-700 45", href: "tel:+4643170045" };

export const ADDRESS = {
  street: "Tomtaholmsvägen 1",
  postal: "269 41 Östra Karup",
  landmark: "Båstadporten, bredvid Willab Garden",
  road: "Vid E6:ans norra infart till Båstad",
};

export const DIRECTIONS_URL =
  "https://www.google.com/maps/dir/?api=1&destination=Tomtaholmsv%C3%A4gen+1%2C+269+41+%C3%96stra+Karup";

export const MAP_EMBED_URL =
  "https://www.google.com/maps?q=Tomtaholmsv%C3%A4gen+1,+269+41+%C3%96stra+Karup&output=embed";

export const SOCIAL = {
  facebook: "https://www.facebook.com/markesportalen/?locale=sv_SE",
  instagram: "https://www.instagram.com/outletbastad/",
};

export const HOURS = [
  { key: "vardag", label: "Måndag–fredag", days: [1, 2, 3, 4, 5], open: 10, close: 18 },
  { key: "lordag", label: "Lördag", days: [6], open: 10, close: 16 },
  { key: "sondag", label: "Söndag", days: [0], open: 11, close: 16 },
];

export const NAV = [
  { id: "sortiment", label: "Sortiment" },
  { id: "varumarken", label: "Varumärken" },
  { id: "butiken", label: "Butiken" },
  { id: "hitta-hit", label: "Hitta hit" },
];

export const BRANDS = [
  "Lyle & Scott", "Lacoste", "Salomon", "Asics", "Björn Borg", "Defender", "Only & Son",
  "Tenson", "Helly Hansen", "Cobolt", "Bagheera", "Only", "Mingel", "Soda", "Zink",
  "Marine", "Daily Sports", "Röhnisch", "Hoka", "Skechers", "Didriksons",
];
